/* unplugin-vue-components disabled */import { render } from "./cart-item.vue?vue&type=template&id=f995fbba"
import script from "./cart-item.vue?vue&type=script&lang=js"
export * from "./cart-item.vue?vue&type=script&lang=js"

import "./cart-item.vue?vue&type=style&index=0&id=f995fbba&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__